import React from 'react';
import { Download, HelpCircle as HelpIcon } from 'react-feather';
import Svg from 'react-inlinesvg';

import { storeIcon } from 'components/TopNav/icons';
import { OnboardingItemsProps } from './OnboardingItems/OnboardingItems';
import { OnboardingItemId } from './OnboardingItem/OnboardingItem';

type OnboardingItems = Pick<OnboardingItemsProps, 'items' | 'secondaryItems'>;

interface OnboardingModalProps extends OnboardingItems {
  title: string;
  description: string;
}

export const getOnboardingItems = (
  stores?: number,
  products?: number,
  handleAction?: (id: string) => void,
): OnboardingModalProps => {
  if (!stores && !products) {
    return {
      title: 'Get Started',
      description: '',
      ...ONBOARDING_ITEMS_NO_STORE(handleAction),
    };
  }

  if (products) {
    return {
      title: 'Great news, you’re ready to sell!',
      description:
        'We’ve included local vendor items in your store. These products are fulfilled by local vendors and you make money on every purchase.',
      ...ONBOARDING_ITEMS_NO_STORE_PRODUCTS(handleAction),
    };
  }

  return { title: '', description: '', items: [] };
};

const ONBOARDING_ITEMS_NO_STORE = (handleAction): OnboardingItems => ({
  items: [
    {
      id: 'NEW_STORE',
      title: 'Create your first store',
      description: 'Start selling in minutes',
      as: 'button',
      icon: <Svg src={storeIcon} />,
      onClick: handleAction,
    },
    {
      id: 'IMPORT_STORES',
      title: 'Connect your Airbnb or Management Software Listings',
      description: 'Create all your stores at once',
      as: 'button',
      icon: <Download />,
      onClick: handleAction,
    },
  ],
});

const ONBOARDING_ITEMS_NO_STORE_PRODUCTS = (handleAction): OnboardingItems => ({
  items: [
    {
      id: 'BACK_TO_STORE',
      title: 'Continue to your store',
      description: 'Add, view, and manage your products',
      as: 'button',
      icon: <Svg src={storeIcon} />,
      onClick: handleAction,
    },
  ],
  secondaryItems: [
    {
      id: OnboardingItemId.localVendorItems,
      title: 'Learn more about local vendor items',
      description: 'View our local vendor item FAQ',
      as: 'a',
      href: 'https://thehostcohelp.zendesk.com/hc/en-us/articles/11463851364877-How-Local-Vendors-work',
      icon: <HelpIcon />,
    },
  ],
});

const isValidAction = (id) => {
  return Object.values(OnboardingItemId).includes(id);
};

const getSavedActions = () => {
  return JSON.parse(localStorage.getItem('onboarding_actions'));
};

export const getVisitedStatus = (id, ownerId) => {
  if (!isValidAction(id)) {
    return false;
  }

  const savedActions = getSavedActions();

  const ownerActions = savedActions?.[ownerId];
  return Boolean(ownerActions?.[id]);
};

export const saveAction = (id, ownerId, callback) => {
  const savedActions = getSavedActions();
  const ownerActions = savedActions?.[ownerId];
  if (!ownerActions?.[id]) {
    localStorage.setItem(
      'onboarding_actions',
      JSON.stringify({
        ...savedActions,
        [ownerId]: {
          ...ownerActions,
          [id]: true,
        },
      }),
    );
  }
  callback(id);
};
